<app-chat-wrapper (promptSubmit)="onPromptSubmit($event)">
  <div class="examples-scrollable-wrapper" [ngClass]="{'padding-bottom': !bannerEnabled}">
    <div class="example-prompt-container">
      <app-example-prompt (exampleSelectEvent)="setPrompt($event)" [banner]="true"
                          [showHeaderMessage]="true" [promptExamplesType]="'ASK_GENE'"
                          [userName]="(userName$ | async)!" [bannerEnabled]="bannerEnabled"/>
    </div>
  </div>
  <ng-container *ngIf="featureFlags.newsBannerWebSearch; else PreviousNewsBanner">
    <app-news-banner class="banner-modal" [headerTitle]="webSearchBannerModalTitle" [type]="'MAIN_CHAT'"
      (close)="onNewsBannerClosed()">
      <div>
        Quickly enable web search or include a URL in your prompt for more accuracy.
        <a target="_blank" class="a-announced-feature" [href]="WebSearchLearnMore">Learn more.</a>
      </div>
    </app-news-banner>
  </ng-container>
  <ng-template #PreviousNewsBanner>
    <app-news-banner *ngIf="featureFlags.imagePrompt && featureFlags.powerPointFileProcessing"
      class="banner-modal" [headerTitle]="imageAndPptBannerTitle" [type]="'MAIN_CHAT'"
      (close)="onNewsBannerClosed()">
      <div>
        Use the paperclip to upload these new file types.
        <a target="_blank" class="a-announced-feature" [href]="learnMore">Learn more.</a>
      </div>
    </app-news-banner>
  </ng-template>
</app-chat-wrapper>
